import React from 'react';
import { render as preactRender } from 'preact';
import { cultureInfo, rootEl } from './app_loader';
import IntlProvider from 'react-intl/lib/components/provider';
import { OriMuiThemeProvider } from '@ori-ui/material-ui';
import Dialog from './Dialog';
const DEFAULT_ORI_CURRENCY = {
    pattern: ['$-n', '$n'],
    decimals: 2,
    ',': ',',
    '.': '.',
    groupSize: [3],
    symbol: '$',
};
export const OriContext = React.createContext({
    oriCurrency: DEFAULT_ORI_CURRENCY,
});
export const render = (data) => {
    if (rootEl) {
        const translations = rootEl.dataset.translations
            ? JSON.parse(decodeURIComponent(rootEl.dataset.translations))
            : {
                _0P: '',
                congratulations: '',
                youHaveLoyaltyPointsThatYouCanUseOnThisProduct: '',
                chooseHowYouWantToPayForIt: '',
            };
        const culture = cultureInfo
            ? JSON.parse(cultureInfo.innerHTML)
            : {
                name: 'en-EN',
                numberFormat: {
                    oriCurrency: DEFAULT_ORI_CURRENCY,
                },
            };
        const { oriCurrency } = culture.numberFormat;
        preactRender(React.createElement(OriMuiThemeProvider, null,
            React.createElement(OriContext.Provider, { value: {
                    oriCurrency,
                } },
                React.createElement(IntlProvider, { locale: culture.name, messages: Object.assign({ loyaltyPrice: ' + {0}' }, translations) },
                    React.createElement(Dialog, Object.assign({}, data))))), rootEl);
    }
};
